import { Component, Output, EventEmitter } from "@angular/core";
import { AppConfigService } from '../../../../configuration/app.config.service';

@Component({
    selector: 'm4u-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent {
    @Output() OnResolved = new EventEmitter();
    // setup re-captcha -> https://www.google.com/recaptcha/admin/create
    SiteKey = this.appConfigService.M4UConfig.captchaKey;

    constructor(private appConfigService: AppConfigService) { }

    OnCaptchaResolved(e) {
        this.OnResolved.emit(e);
    }
}